export default __webpack_public_path__ + "static/main-pic1-6dc0ead7b5ac08dcc5aab4a2b969ca5d.png";